import React from 'react';
import { TrashIcon, PencilSquareIcon } from '@heroicons/react/20/solid';
import { useLinksContext } from '@pages/Links';
import { LINK_TYPE } from '@utils/constants';
import SingleIcon from '@utils/icons/SingleIcon';

const LinkItem = ({
  _id,
  title,
  link,
  strasse,
  plz,
  ort,
  telefonnummer,
  email,
  geburtstag,
  netzwerk,
  icon,
  position,
  type,
}) => {
  const {
    setShowSlideIn,
    setLinkEdit,
    setEditIconValue,
    editIconValue,
    setOpenDeleteModal,
  } = useLinksContext();

  // Geburtstag umformatieren
  const date = new Date(geburtstag);
  const geburtstagFormatted = date.toLocaleDateString('ch-DE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return (
    <li
      // key={id}
      className="py-4 my-4 overflow-hidden bg-white rounded-lg shadow-lg hover:shadow-sm transition-shadow"
    >
      <div className="flex">
        <div className="self-center text-4xl px-3">
          <SingleIcon iconComponentName={icon} size={40} color="#000" />
        </div>
        <div className="grid px-3">
          <h3 className="self-center text-lg font-semibold text-gray-900">
            {title}
          </h3>
          <p className="self-center text-lg overflow-hidden whitespace-nowrap text-gray-700">
            {type === LINK_TYPE.TELEFON_PRIVAT ||
            type === LINK_TYPE.TELEFON_ARBEIT ||
            type === LINK_TYPE.TELEFON
              ? telefonnummer
              : type === LINK_TYPE.EMAIL_ARBEIT ||
                type === LINK_TYPE.EMAIL_PRIVAT ||
                type === LINK_TYPE.EMAIL
              ? email
              : type === LINK_TYPE.ADRESSE_FIRMA ||
                type === LINK_TYPE.ADRESSE_PRIVAT ||
                type === LINK_TYPE.ADRESSE
              ? `${strasse} ${plz} ${ort}`
              : type === LINK_TYPE.SOCIAL_MEDIA
              ? 'https://' + link
              : type === LINK_TYPE.GEBURTSTAG
              ? geburtstagFormatted
              : link}
          </p>
        </div>
        <div className="self-center ml-auto">
          <PencilSquareIcon
            className="ml-2 h-7 w-7 text-gray-900"
            onClick={() => {
              setLinkEdit({
                new: false,
                title,
                link,
                icon,
                _id,
                type,
                position: position,
                strasse,
                plz,
                ort,
                telefonnummer,
                email,
                geburtstag,
                netzwerk,
              });
              setEditIconValue(icon);
              setShowSlideIn(true);
            }}
            // Daten des Links mitübermitteln, dass diese bereits als Wert im Form angezeigt werden können
          />
        </div>
        <div className="self-center pr-4">
          <TrashIcon
            className="ml-2 h-7 w-7 text-red-600"
            onClick={() => {
              setOpenDeleteModal(true);
              setLinkEdit({ _id });
            }}
          />
        </div>
      </div>
    </li>
  );
};

export default LinkItem;
